export default __webpack_public_path__ + "static/media/7.4975e2c3.jpg";